// @ts-check

import { stripOsName } from 'modules/queries/asset/useDetails';

/** @param {string} osName */
export const checkIsWpOptimized = (osName) => {
	return osName.toLowerCase().includes('wordpress optimized');
};

/**
 * - removes square backets and contents from osName (for example:
 * [App:WordPress Optimized])
 * - just returns the osVersion if is windows
 * @param {object} params
 * @param {string} params.osName
 * @param {string} params.osVersion
 * @param {boolean} params.isWindows
 * */
export const createOsDescription = ({ osName, osVersion, isWindows }) => {
	const osNameStripped = stripOsName(osName);
	return isWindows ? osVersion : `${osNameStripped} ${osVersion}`;
};

/**
 * @param {object} params
 * @param {string} params.osName
 * @param {string} params.osVersion
 * @param {string} params.osBit
 * @returns {string}
 */
export const createOsValue = ({ osName, osVersion, osBit }) =>
	JSON.stringify({ osName, osVersion, osBit });

/** @type {{[key: string]: {label: string, displayOrder: number, tooltip: {title: string, summary: string, description: string}}}} */
export const managementMap = {
	'Self-Managed': {
		label: 'Self managed',
		displayOrder: 1,
		tooltip: {
			title: 'What is self managed?',
			summary:
				'Management and support of the system and applications is provided by the user',
			description:
				'We manage the hardware and system health. You handle server maintenance, monitoring, updates, and configuration.',
		},
	},
	'Core-Managed': {
		label: 'Core managed',
		displayOrder: 2,
		tooltip: {
			title: 'What is core managed?',
			summary:
				'Includes installation, maintenance, and support of core software packages',
			description:
				'We manage the OS and core services. You handle all other software updates and maintenance.',
		},
	},
	'Fully-Managed': {
		label: 'Fully managed',
		displayOrder: 3,
		tooltip: {
			title: 'What is fully managed?',
			summary:
				'Our support team monitors the server, intervenes during detected outages, and helps maintain security through managed updates',
			description:
				'Our support team monitors the server, intervenes during detected outages, and helps maintain security through managed updates.',
		},
	},
};
